export default {
	'show-all-columns': 'Show all columns',
	'total-arrested': 'Total arrested',
	'total-payments': 'Total payments',
	'the-difference': 'The difference'
}